@for (
  inspectionReportGroup of inspectionReportGroups().items;
  track inspectionReportGroup.group.groupInfo.groupName
) {
  <app-report-group-v2 [inspectionReportGroup]="inspectionReportGroup" />
}
